import { BaseModel } from '@core/data-access';
import { Exclude, Expose } from 'class-transformer';

@Exclude()
export class VerificationApplicationModel extends BaseModel {
  @Expose() appId!: string | null;
  @Expose() last4NRIC!: string | null;
  @Expose() otpCode!: string | null;
}
